import React from 'react';
import HappyHomeLogo from '../../../images/Logo/HH25_Logo_Principal.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container-max-width">
        {/* Logo centrado arriba */}
        <div className="footer-logo-row">
          <a href="/" className="footer-logo-link">
            <img src={HappyHomeLogo} alt="Logo" className="footer-logo" />
          </a>
        </div>
        {/* Columnas alineadas abajo */}
        <div className="footer-columns-row">
          {/* Columna 1: Sobre Nosotros */}
          <div className="footer-column">
            <p className="footer-column-title">SOBRE NOSOTROS</p>
            <a href="#">Cómo funciona</a>
            <a href="#">Soluciones para familias</a>
            <a href="#">Soluciones para empresas</a>
            <a href="#">Soluciones para quienes buscan trabajo</a>
          </div>
          {/* Columna 2: Ayuda y Soporte */}
          <div className="footer-column">
            <p className="footer-column-title">AYUDA Y SOPORTE</p>
            <a href="#">Preguntas frecuentes</a>
            <a href="#">Términos y condiciones</a>
            <a href="#">Política de privacidad</a>
          </div>
          {/* Columna 3: Seguinos */}
          <div className="footer-column">
            <p className="footer-column-title">SEGUÍNOS</p>
            <div style={{display: 'flex', gap: '0.5em'}}>
              <a href="#" aria-label="TikTok"><i className="fab fa-tiktok"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
            </div>
          </div>
          {/* Columna 4: Contacto */}
          <div className="footer-column">
            <p className="footer-column-title">CONTACTO</p>
            <a href="mailto:info@happyhome.com.ar">info@happyhome.com.ar</a>
          </div>
          {/* Columna 5: WhatsApp */}
          <div className="footer-column">
            <p className="footer-column-title">WHATSAPP</p>
            <a href="#">(ENLACE)</a>
          </div>
        </div>
        {/* Fila inferior */}
        <div className="footer-bottom-row">
          <span>© 2025 Happy Home</span>
        </div>
      </div>
      {/* Barra violeta inferior */}
      <div className="footer-bar"></div>
    </footer>
  );
};

export default Footer;
